module.exports = __webpack_public_path__ + "static/img/div_ppt3.9d7c1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/div_ppt3.png
// module id = /xy3
// module chunks = 1